import React, { useEffect, useRef, useState } from 'react';
import * as rsuite from 'rsuite';

import Layout from '../../Layout/PrivateLayout.js';
import * as General from '../General/General.js';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import * as BiIcon from "react-icons/bi";
import Auto_Product from '../Product/Auto_Product.js';
import Auto_Supplier from '../User/Auto_User.js';
import Drp_StoreRoom from '../StoreRoom/Drp_StoreRoom.js';
import moment from 'moment-jalaali';
import DatePicker from 'react-datepicker2';
import GetTax from '../Common/GetTax.js';
import PN from "persian-number";
import {Modal} from "react-bootstrap";


const InsertBuyOrderIndex = () => {

    //#region Const
    const toaster = rsuite.useToaster();
    let navigate = useNavigate();
    const ProductRef = useRef()
    const SupplierRef = useRef()
    const GetTaxRef = useRef()
    const StoreRef = useRef()
    const [ItemList, setItemList] = useState([]);
    const [HeaderId, setHeaderId] = useState(localStorage.getItem("BuyOrderHeaderId"));
    const [Tax, setTax] = useState(0);
    const [FiscalYearId, setFiscalYearId] = useState(localStorage.getItem("FiscalYearId"));
    const [Code, setCode] = useState("");

    const [StoreRoomId, setStoreRoomId] = useState(-1);
    const [DiscountPercent, setDiscountPercent] = useState(0);
    const [DiscountPrice, setDiscountPrice] = useState(0);
    const [DiscountType, setDiscountType] = useState(0);
    const [SumItemPrice, setSumItemPrice] = useState(0); // محموع قیمت خالص آیتم ها
    const [HeaderDiscount, setHeaderDiscount] = useState(0); // مجموع کل تخفیف
    const [HeaderTax, setHeaderTax] = useState(0); // مالیات کل

    const [SumTotalPrice, setSumTotalPrice] = useState(0);  // قیمت کل با درنظر گرفتن مالیات و تخفیف هر آیتم
    const [HeaderPrice, setHeaderPrice] = useState(0); // قیمت کل فاکتور
    const [FreightPrice, setFreightPrice] = useState(0);
    const [InsertDate, setInsertDate] = useState(moment(new Date())); // moment((new Date).format("jYYYY/jMM/jDD"))
    const [RecieptDate, setRecieptDate] = useState(moment(new Date())); // moment((new Date).format("jYYYY/jMM/jDD"))
    const [ConfirmModal, setConfirmModal] = useState(false);
    const [SupplierId, setSupplierId] = useState(General.GuidEmpty());
    const [Supplier, setSupplier] = useState("");
    const [IsConfirm, setIsConfirm] = useState(0);
    //#region Check All Item
    let checked = false;
    let indeterminate = false;

    if ([...ItemList].filter(item => item.DiscountType == 1).length === ItemList.length) {
        checked = true;
    } else if ([...ItemList].filter(item => item.DiscountType == 1).length === 0) {
        checked = false;
    } else if ([...ItemList].filter(item => item.DiscountType == 1).length > 0 && [...ItemList].filter(item => item.DiscountType == 1).length < ItemList.length) {
        indeterminate = true;
    }
    //#endregion

    //#endregion

    const Supplier_Change = (e) => {
        setSupplierId(General.GuidEmpty())
        if (e.split("|").length > 1) {
            setSupplier(e.split("|")[1]);
            setSupplierId(e.split("|")[0]);
            return;
        }
        setSupplier(e);
        SupplierRef.current.BindSupplier(e);
    }

    const Supplier_Select = (e) => {
        setSupplier(e.split("|")[1]);
        setSupplierId(e.split("|")[0]);
    }


    const change_DiscountType = (e, checked) => {
        setDiscountType(checked == true ? 1 : 0)
    }


    const InsertDate_Change = e => {
        // setItemList([]);
        var m = moment(e.format()).format('jYYYY/jMM/jDD');
        setInsertDate(moment(m, 'jYYYY/jMM/jDD'));
    }

    const RecieptDate_Change = e => {
        var m = moment(e.format()).format('jYYYY/jMM/jDD');
        setRecieptDate(moment(m, 'jYYYY/jMM/jDD'));
    }

    const Change_FreightPrice = (e) => {
        // var temp = [...ItemList.filter(item => item.ProductId !== General.GuidEmpty())];

        setFreightPrice(e.replaceAll(',', ''));
        var freightPrice = e > '0' ? e.replaceAll(',', '') : 0
        // var discountPrice = DiscountPrice;
        // var discountPercent = DiscountPercent;
        // if (DiscountType == 1) // تخفیف درصد می باشد
        //     discountPrice = discountPercent == 0 ? 0 : Math.trunc((SumTotalPrice * 1 + freightPrice * 1) * discountPercent / 100);
        // else
        //     discountPercent = discountPrice == 0 ? 0 : Number.parseFloat((SumTotalPrice * 1 + freightPrice * 1) * 100 / discountPrice).toFixed(2)
        var headerPrice = SumTotalPrice * 1 + freightPrice * 1 - DiscountPrice;


        setHeaderPrice(headerPrice);
        // setDiscountPercent(discountPercent);
        // setDiscountPrice(discountPrice);
        // setHeaderDiscount(temp.length == 0 ? discountPrice : temp.map(o => o.DiscountPrice).reduce((a, b) => a + b) + discountPrice*1);

    }


    const Change_DiscountPrice = (e) => {
        var temp = [...ItemList.filter(item => item.ProductId !== General.GuidEmpty())];
        var discountPrice = e > '0' ? e.replaceAll(',', '') : 0
        var discountPercent = SumTotalPrice == 0 ? 0 : Number.parseFloat((discountPrice * 1) * 100 / SumTotalPrice).toFixed(2)
        setDiscountPrice(discountPrice);
        setDiscountPercent(discountPercent);
        setHeaderPrice(SumTotalPrice * 1 + FreightPrice * 1 - discountPrice);
        setHeaderDiscount(temp.length == 0 ? discountPrice : temp.map(o => o.DiscountPrice).reduce((a, b) => a + b) + discountPrice);

    }

    const Change_DiscountPercent = (e) => {
        var temp = [...ItemList.filter(item => item.ProductId !== General.GuidEmpty())];

        var discountPercent = e;
        var discountPrice = Math.trunc((SumTotalPrice * 1) * e / 100);
        setDiscountPrice(discountPrice);
        setDiscountPercent(discountPercent);
        setHeaderPrice(SumTotalPrice * 1 + FreightPrice * 1 - discountPrice);
        setHeaderDiscount(temp.length == 0 ? discountPrice : temp.map(o => o.DiscountPrice).reduce((a, b) => a + b) + discountPrice);

    }


    const Blur_Header = (e) => {
        var temp = [...ItemList];

        temp.forEach(element => {
            var sumTotalRecieptPrice = temp.filter(x => x.Editable).length > 0 ? temp.filter(x => x.Editable).map(o => o.TotalPrice).reduce((a, b) => a + b) : 0;
            var sumRecieptHeaderDiscount = temp.filter(x => !x.Editable) > 0 ? temp.filter(x => !x.Editable).map(o => o.HeaderDiscount).reduce((a, b) => a + b) : 0;
            if (element.ProductId != General.GuidEmpty() && element.Editable) {
                var headerDiscountEfect = Math.trunc(element.TotalPrice * (DiscountPrice - sumRecieptHeaderDiscount) / (sumTotalRecieptPrice * element.Count));
                element.HeaderDiscount = headerDiscountEfect;
                element.FinalPrice = element.Price * 1 - element.DiscountPrice * 1 - headerDiscountEfect * 1 + element.Tax * 1
            }
        });
        setItemList(temp)
    }

    //#region Methods


    const GetById = () => {
        trackPromise(
            fetch(General.ApiRoute() + '/BuyOrder/GetHeaderById', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'Id': localStorage.getItem("BuyOrderHeaderId")
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    setInsertDate(moment(result.insertDate, 'jYYYY/jMM/jDD'))
                    setHeaderPrice(result.price);
                    setStoreRoomId(result.storeRoomId);
                    setCode(result.code);
                    setSupplierId(result.supplierId);
                    setSupplier(result.supplierFullName + '(' + result.supplierMobile + ')')
                    setDiscountPercent(result.discountPercent)
                    setDiscountPrice(result.discountPrice)
                    setFreightPrice(result.freightPrice)
                    setDiscountType(result.discountType)
                    setIsConfirm(result.isConfirm)
                    GetByHeaderId(result.freightPrice, result.discountPrice);

                })
        )
    }
    const GetByHeaderId = (FreightPrice, DiscountPrice) => {
        trackPromise(
            fetch(General.ApiRoute() + '/BuyOrder/GetByHeaderId', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'HeaderId': localStorage.getItem("BuyOrderHeaderId")
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    var tmp = [];

                    if (result.length > 0) {
                        setHeaderTax(result.map(o => o.tax).reduce((a, b) => a + b));
                        setHeaderDiscount(result.map(o => o.discountPrice).reduce((a, b) => a + b) + DiscountPrice * 1);
                        setSumItemPrice(result.map(o => (o.price * o.count) * 1).reduce((a, b) => a + b));
                        setSumTotalPrice(result.map(o => o.totalPrice).reduce((a, b) => a + b));
                        setHeaderPrice(result.map(o => o.totalPrice).reduce((a, b) => a + b) * 1 + FreightPrice * 1 - DiscountPrice * 1);
                        for (var i = 0; i < result.length; i++) {
                            tmp.push({
                                row: i + 1,
                                Id: result[i].id,
                                Price: result[i].price,
                                Tax: result[i].tax,
                                TotalPrice: result[i].totalPrice,
                                DiscountPrice: result[i].discountPrice,
                                DiscountPercent: result[i].discountPercent,
                                DiscountType: result[i].discountType,
                                HeaderDiscount: result[i].headerDiscount,
                                Count: result[i].count,
                                Product: result[i].product,
                                ProductId: result[i].productId,
                                ProductIdentityNo: result[i].productIdentityNo,
                                InsertDateTime: result[i].insertDate + " " + result[i].insertTime,
                                status: "",
                                Editable: result[i].returnCount == 0 ? true : false,
                                ReturnCount: result[i].returnCount,
                                FinalPrice: Math.trunc(result[i].price * 1 - result[i].discountPrice * 1 - result[i].headerDiscount * 1 + result[i].tax * 1)
                            })
                        }
                        setItemList(tmp)
                    }

                })
        )
    }

    const Reset = () => {
        setItemList([]);
        setHeaderId(General.GuidEmpty());
        setCode("");
        setStoreRoomId(-1);
        setHeaderPrice(0);
        setDiscountType(1);
        setSumItemPrice(0);
        setHeaderDiscount(0);
        setHeaderTax(0);
        setHeaderDiscount(0)
        setDiscountPercent(0)
        setDiscountPrice(0)
        setFreightPrice(0);
        setInsertDate(moment(new Date()));
        setSupplierId(General.GuidEmpty());
        setSupplier("");
        SupplierRef.current.focus();

    }

    const Save = (IsConfirm) => {

        if (StoreRoomId == "-1" && IsConfirm == 1) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("انتخاب انبار اجباری می باشد")), 'topCenter')
            return;
        }
        if (InsertDate == "" || InsertDate == null) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage(" وارد کردن تاریخ فاکتور اجباری می باشد")), 'topCenter')
            return;
        }
        if (IsConfirm == 1 && (RecieptDate == "" || RecieptDate == null)) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage(" وارد کردن تاریخ رسید اجباری می باشد")), 'topCenter')
            return;
        }
        if (IsConfirm == 1 && (InsertDate > RecieptDate)) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("تاریخ رسید  نمی تواند قبل از تاریخ فاکتور اجباری می باشد")), 'topCenter')
            return;
        }
        if (SupplierId == General.GuidEmpty()) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage(" انتخاب تامین کننده اجباری می باشد")), 'topCenter')
            return;
        }
        if (ItemList.length == 0 || (ItemList.length == 1 && ItemList[0].status != "EDIT")) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage(" لیست رسید محصول اجباری می باشد")), 'topCenter')
            return;
        }
        var RequestOptions = {
            data: {
                "Id": HeaderId == null ? General.GuidEmpty() : HeaderId,
                "SupplierId": SupplierId,
                "Price": HeaderPrice * 1,
                "InsertDate": moment(InsertDate.format()).format('jYYYY/jMM/jDD'),
                "StoreRoomId": StoreRoomId,
                "FiscalYearId": FiscalYearId * 1,
                "FreightPrice": FreightPrice * 1,
                "DiscountType": DiscountType ? 1 : 0,
                "IsConfirm": IsConfirm * 1,
                "DiscountPercent": DiscountPercent * 1,
                "DiscountPrice": DiscountPrice * 1,
                "Children": [...ItemList].filter(item => item.ProductId != General.GuidEmpty() && item.status != 'EDIT'),
            },
            url: General.ApiRoute() + "/BuyOrder/Save",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json',
                "IsConfirm": IsConfirm,
                "StoreRoomId": StoreRoomId,
                "RecieptDate": RecieptDate != null ? moment(RecieptDate.format()).format('jYYYY/jMM/jDD') : "",
            }
        }

        trackPromise(
            axios(RequestOptions)
                .then(function (result) {
                    if (result.data.includes("OK")) {
                        if (IsConfirm == 1) {
                            var comment = result.data.split("|")[1];
                            toaster.push(General.ShowMessage('success', General.SuccessMessage("ذخیزه شده است، شماره رسید :" + comment)), 'topCenter')
                        }
                        else
                            toaster.push(General.ShowMessage('success', General.SuccessMessage("ذخیزه شده است")), 'topCenter')
                        if (HeaderId == General.GuidEmpty())
                            Reset();
                        else {
                            localStorage.removeItem("BuyOrderHeaderId");
                            navigate("/BuyOrder")
                        }
                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )
    }

    const onEditItem = (row) => {
        var temp = [...ItemList];
        var index = temp.findIndex(x => x.row == row);
        if (index != -1) {
            temp[index].status = "EDIT";
        }
        setItemList(temp);
    }

    const NewItem = () => {
        setItemList([
            ...ItemList,
            {
                row: ItemList.length + 1,
                ProductId: General.GuidEmpty(),
                Product: '',
                Editable: true,
                Id: General.GuidEmpty(),
                status: "EDIT",
                RefId: General.GuidEmpty(),
                Count: 0,
                TotalPrice: 0,
                Price: 0,
                Tax: 0,
                DiscountPrice: 0,
                DiscountPercent: 0,
                HeaderDiscount: 0,
                FinalPrice: 0,
                ReturnCount: 0,
                DiscountType: DiscountType,
            }

        ]);
        setTimeout(() => {
            ProductRef.current.Bind(-1, -1, '')
            ProductRef.current.focus()

        }, 200)

    }

    const Change_Item = (row, dataType, value) => {
        var temp = [...ItemList];
        var index = temp.findIndex(x => x.row == row);

        if (index != -1) {

            var price = temp[index].Price;
            var discountPrice = temp[index].DiscountPrice;
            var discountPercent = temp[index].DiscountPercent;
            var tax = temp[index].Tax;
            var totalPrice = 0;

            if (dataType == "Price") {
                price = value != "0" && value != 0 ? value.replaceAll(',', '') : 0;
                discountPrice = DiscountType == 1 ? Math.trunc(price * temp[index].DiscountPercent * 1 / 100) : discountPrice;
                discountPercent = DiscountType == 1 ? temp[index].DiscountPercent : Number.parseFloat(discountPrice * 100 / price).toFixed(2);
                tax = Math.trunc((price * 1 - discountPrice * 1) * Tax * 1 / 100);

                totalPrice = (price * 1 + tax * 1 - discountPrice * 1) * temp[index].Count * 1;
                temp[index].DiscountPrice = discountPrice;
                temp[index].DiscountPercent = discountPercent;
                temp[index].Price = price * 1;
                temp[index].TotalPrice = totalPrice;
                temp[index].Tax = tax;
            }
            else if (dataType == "Count") {
                temp[index].Count = value * 1;
                totalPrice = (price * 1 + tax * 1 - discountPrice * 1) * value * 1;
                temp[index].TotalPrice = totalPrice;
            }
            else if (dataType == "DiscountPrice") {
                discountPrice = value != "0" && value != 0 ? value.replaceAll(',', '') * 1 : 0;
                discountPercent = Number.parseFloat(discountPrice * 1 * 100 / price * 1).toFixed(2);
                tax = Math.trunc((price * 1 - discountPrice * 1) * Tax * 1 / 100);
                totalPrice = (price * 1 + tax * 1 - discountPrice * 1) * temp[index].Count * 1;
                temp[index].DiscountPrice = discountPrice;
                temp[index].DiscountPercent = discountPercent;
                temp[index].TotalPrice = totalPrice;
                temp[index].Tax = tax;
            }

            else if (dataType == "DiscountPercent") {
                discountPercent = value * 1;
                discountPrice = Math.trunc(value * price / 100);
                tax = Math.trunc((price * 1 - discountPrice * 1) * Tax * 1 / 100);
                totalPrice = (price * 1 + tax * 1 - discountPrice * 1) * temp[index].Count;
                temp[index].DiscountPrice = discountPrice;
                temp[index].DiscountPercent = discountPercent;
                temp[index].TotalPrice = totalPrice;
                temp[index].Tax = tax;
            }


            else if (dataType == "ProductRef" && value != undefined) {
                temp[index].ProductId = General.GuidEmpty();
                if (value.indexOf("|") > 1) {
                    temp[index].Product = value.split("|")[1];
                    temp[index].ProductId = value.split("|")[0];
                    return;
                }
                temp[index].Product = value;
                ProductRef.current.Bind(-1, -1, value)
            }


        }
        setItemList(temp);
    }


    const Blur_Item = (row) => {
        var temp = [...ItemList];
        var index = temp.findIndex(x => x.row == row);

        if (index != -1) {

            var sumTotalPrice = temp.map(o => o.TotalPrice).reduce((a, b) => a + b);
            var sumTotalRecieptPrice = temp.filter(x => x.Editable).length > 0 ? temp.filter(x => x.Editable).map(o => o.TotalPrice).reduce((a, b) => a + b) : 0;
            var sumRecieptHeaderDiscount = temp.filter(x => !x.Editable).length > 0 ? temp.filter(x => !x.Editable).map(o => o.HeaderDiscount).reduce((a, b) => a + b) : 0;

            var discountPrice = DiscountPrice;
            var discountPercent = DiscountPercent;
            if (DiscountType == 1) // تخفیف درصد می باشد
                discountPrice = discountPercent == 0 ? 0 : Math.trunc((sumTotalPrice * 1) * discountPercent / 100);
            else
                discountPercent = discountPrice == 0 ? 0 : Number.parseFloat((discountPrice * 1) * 100 / sumTotalPrice).toFixed(2)

            setHeaderTax(temp.map(o => o.Tax).reduce((a, b) => a + b));
            setHeaderDiscount(temp.map(o => o.DiscountPrice).reduce((a, b) => a + b) + discountPrice * 1);
            setSumItemPrice(temp.map(o => (o.Price * o.Count) * 1).reduce((a, b) => a + b));
            setSumTotalPrice(sumTotalPrice);
            setHeaderPrice(sumTotalPrice * 1 + FreightPrice * 1 - discountPrice * 1);
            setDiscountPercent(discountPercent)
            setDiscountPrice(discountPrice)
            temp.forEach(element => {
                if (element.Editable) {
                    var headerDiscountEfect = element.TotalPrice * (discountPrice - sumRecieptHeaderDiscount) / (sumTotalRecieptPrice * element.Count);
                    element.HeaderDiscount = headerDiscountEfect;
                    element.FinalPrice = Math.trunc(element.Price * 1 - element.DiscountPrice * 1 - headerDiscountEfect * 1 + element.Tax * 1);

                }
            });

        }

        setItemList(temp);
    }

    const Select_Item = (row, dataType, value) => {
        var temp = [...ItemList];
        var index = temp.findIndex(x => x.row == row);
        if (index != -1) {
            temp[index].ProductId = value.split("|")[0];
            temp[index].Product = value.split("|")[1];
            setTimeout(() => {
                const inputElement = document.querySelector('.CountItem');
                if (inputElement) {
                    inputElement.focus();

                }
                temp[index].Count = 1;
                setItemList(temp);


            }, 200)
        }
    }

    const SaveItem = (row) => {


        var temp = [...ItemList];
        var index = temp.findIndex(x => x.row == row);
        if (index != -1) {

            if (temp[index].Price == "0" || temp[index].Price == 0) {
                toaster.push(General.ShowMessage('error', General.ErrorMessage("قیمت محصول اجباری می باشد")), 'topCenter')
                return;
            }
            if (temp[index].Count == "0" || temp[index].Count == 0) {
                toaster.push(General.ShowMessage('error', General.ErrorMessage("تعداد محصول اجباری می باشد")), 'topCenter')
                return;
            }
            if (temp[index].ProductId == General.GuidEmpty()) {
                toaster.push(General.ShowMessage('error', General.ErrorMessage("انتخاب محصول اجباری می باشد")), 'topCenter')
                return;
            }


            temp[index].status = "";
            setHeaderTax(temp.map(o => o.Tax).reduce((a, b) => a + b));
            setHeaderDiscount(temp.map(o => o.DiscountPrice).reduce((a, b) => a + b) + DiscountPrice * 1);
            setSumItemPrice(temp.map(o => (o.Price * o.Count) * 1).reduce((a, b) => a + b));
            setSumTotalPrice(temp.map(o => o.TotalPrice).reduce((a, b) => a + b));
            setHeaderPrice(temp.map(o => o.TotalPrice).reduce((a, b) => a + b) * 1 + FreightPrice * 1 - DiscountPrice * 1);
            if (temp.filter(item => item.ProductId == General.GuidEmpty()).length == 0) {
                temp.push({
                    row: temp.length + 1,
                    ProductId: General.GuidEmpty(),
                    Product: '',
                    Editable: true,
                    Id: General.GuidEmpty(),
                    status: "EDIT",
                    RefId: General.GuidEmpty(),
                    Count: 0,
                    TotalPrice: 0,
                    Price: 0,
                    Tax: 0,
                    DiscountPrice: 0,
                    DiscountPercent: 0,
                    HeaderDiscount: 0,
                    FinalPrice: 0,
                    DiscountType: DiscountType,
                    ReturnCount: 0,
                })


                setItemList(temp);
                setTimeout(() => {
                    ProductRef.current.Bind(-1, -1, '')
                    ProductRef.current.focus()

                }, 200)

            }
        }


    }

    const ItemOnKeyUp = (e, row) => {
        if (e.code == "Enter") {
            SaveItem(row);

        }
        if (e.code == "Delete") {
            DeleteItem(row);

        }
    }


    // const HeaderOnKeyUp = (e) => {
    //     var temp = [...ItemList.filter(item => item.status == "EDIT")];

    //     if (temp.length > 0) {
    //         if (e.code == "Enter") {
    //             SaveItem(temp[0].row);

    //         }
    //         if (e.code == "Delete") {
    //             DeleteItem(temp[0].row);

    //         }
    //     }
    // }


    const HeaderOnKeyUp = (e) => {
        if (e.key == "Enter") {

            if ([...ItemList].length > 0) {
                var index = [...ItemList].findIndex(x => x.status == "EDIT");
                if (index != -1) {
                    SaveItem([...ItemList][index].row);
                    return;
                }
                else {
                    NewItem();
                    return;

                }
            }
            else {
                NewItem();
            }
        }
        if (e.key == "Delete") {
            var index = [...ItemList].findIndex(x => x.status == "EDIT");

            if (index != -1)
                DeleteItem([...ItemList][index].row);
            else if ([...ItemList].length > 0)
                DeleteItem([...ItemList][[...ItemList].length - 1].row);
        }


        if (e.key == "Escape") {
            localStorage.removeItem("BuyOrderHeaderId");
            navigate("/BuyOrder")
        }

        if (e.shiftKey && e.code === "KeyS") {
            Save(0);
        }


        if (e.shiftKey && e.code === 'KeyR') {
            ShowRecieptInsert();
        }

        if (e.shiftKey && e.code === 'KeyN') {
            Reset();
        }
    }

    const Item_CheckAll = (checked) => {
        var temp = [...ItemList];
        checked ? temp.filter(x => x.Editable).map(item => item.DiscountType = 1) :
            temp.filter(x => x.Editable).map(item => item.DiscountType = 0);
        setItemList(temp);
    };

    const ItemDiscountType_Check = (checked, row) => {
        var temp = [...ItemList];
        var index = temp.findIndex(x => x.row == row);
        if (index != -1) {
            temp[index].DiscountType = checked ? 1 : 0;
        }
        setItemList(temp);
    };

    const DeleteItem = (row) => {

        var temp = [...ItemList.filter(item => item.row !== row)];
        setItemList(temp);
        if (temp.length > 0) {
            setHeaderTax(temp.map(o => o.Tax).reduce((a, b) => a + b));
            setHeaderDiscount(temp.map(o => o.DiscountPrice).reduce((a, b) => a + b));
            setSumItemPrice(temp.map(o => (o.Price * o.Count) * 1).reduce((a, b) => a + b));
            setSumTotalPrice(temp.map(o => o.TotalPrice).reduce((a, b) => a + b) * 1);
            setHeaderPrice(temp.map(o => o.TotalPrice).reduce((a, b) => a + b) * 1 - DiscountPrice * 1 + FreightPrice * 1);
            var sumTotalRecieptPrice = temp.filter(x => x.Editable).length > 0 ? temp.filter(x => x.Editable).map(o => o.TotalPrice).reduce((a, b) => a + b) : 0;
            var sumRecieptHeaderDiscount = temp.filter(x => !x.Editable).length > 0 ? temp.filter(x => !x.Editable).map(o => o.HeaderDiscount).reduce((a, b) => a + b) : 0;

            temp.forEach(element => {
                if (element.Editable) {
                    var headerDiscountEfect = element.TotalPrice * (DiscountPrice - sumRecieptHeaderDiscount) / (sumTotalRecieptPrice * element.Count);
                    element.HeaderDiscount = headerDiscountEfect;
                    element.FinalPrice = Math.trunc(element.Price * 1 - element.DiscountPrice * 1 - headerDiscountEfect * 1 + element.Tax * 1);

                }
            });
        }
        else {
            setHeaderTax(0);
            setHeaderDiscount(0);
            setSumItemPrice(0);
            setSumTotalPrice(0);
            setHeaderPrice(FreightPrice * 1 - DiscountPrice * 1);
        }


    }

    const ShowRecieptInsert = () => {
        setConfirmModal(true);
        setRecieptDate(InsertDate);
        setTimeout(() => {
            StoreRef.current.Bind(-1)
        }, 200)
    }

    const CheckPermission = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 16);
        myHeaders.append("Operation", localStorage.getItem("BuyOrderHeaderId") && localStorage.getItem("BuyOrderHeaderId") != undefined != General.GuidEmpty() ? 3 : 1);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        navigate("/AccessDenied");
                    }
                    else {
                        if (localStorage.getItem("BuyOrderHeaderId") != undefined && localStorage.getItem("BuyOrderHeaderId") != General.GuidEmpty())
                            GetById();
                        GetTaxRef.current.Get();
                        SupplierRef.current.BindSupplier('');

                        // ParentGroupRef.current.BindGroupByParentId(-1, 0);
                        // StoreRef.current.Bind(-1);
                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }

    useEffect(() => {
        CheckPermission();
        document.title = "ثبت فاکتور خرید";
        SupplierRef.current.focus();

    }, [])
    //#endregion







    return (

        <Layout title="ثبت فاکتور خرید" >
            <div className="h-100 p-1" onKeyUp={HeaderOnKeyUp}>
                <rsuite.Panel className="bg-white ">
                    <rsuite.Grid fluid>
                        <rsuite.Row>
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className="text-left" >
                                <rsuite.Button appearance="primary" size="xs" className="m-1" onClick={() => Save(0)}>  ثبت</rsuite.Button>
                                <rsuite.Button appearance="primary" size="xs" className="m-1" onClick={ShowRecieptInsert}>  ثبت فاکتور و رسید ورود به انبار</rsuite.Button>
                                <rsuite.Button appearance="primary" color="green" size="xs" className="m-1" onClick={Reset}>  جـــدید</rsuite.Button>
                                <rsuite.Button appearance="primary" color="yellow" size="xs" className="m-1" onClick={() => (localStorage.removeItem("BuyOrderHeaderId"), navigate("/BuyOrder"))}>  بازگشت</rsuite.Button>
                                <GetTax ref={GetTaxRef} onSubmit={(value) => setTax(value)} />
                            </rsuite.Col>
                        </rsuite.Row>
                    </rsuite.Grid>
                    <hr />
                    <rsuite.Row className='p-1'>
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <rsuite.Checkbox onChange={(e, checked) => change_DiscountType(e, checked)} checked={DiscountType} value={DiscountType} /> &nbsp;    تخفیف به درصد می باشد

                        </rsuite.Col>
                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            <label>شماره فاکتور</label>
                            <rsuite.Input disabled value={Code} onChange={(e) => setCode(e)} />
                        </rsuite.Col>
                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            <label>تامین کننده</label>
                            <Auto_Supplier disabled={IsConfirm != 0 ? true : false} value={Supplier} onChange={Supplier_Change} onSelect={Supplier_Select} ref={SupplierRef} />
                        </rsuite.Col>
                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            <label> تاریخ </label>
                            <DatePicker className="rs-input" isGregorian={false} timePicker={false} icon={BiIcon.BiCalendar} value={InsertDate} onChange={InsertDate_Change} />


                        </rsuite.Col>

                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            <label>هزینه باربری (ریال)</label>
                            <rsuite.Input value={PN.sliceNumber(FreightPrice)} onChange={Change_FreightPrice} />
                            <rsuite.Text className='Font10 float-start' as='sub'>{FreightPrice != "0" ? <>{PN.convert(FreightPrice)} ریال</> : ""}</rsuite.Text>

                        </rsuite.Col>
                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            <label>درصد تخفیف</label>
                            <rsuite.Input disabled={DiscountType == 1 ? false : true} value={DiscountPercent} onChange={Change_DiscountPercent} onBlur={Blur_Header} />

                        </rsuite.Col>
                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            <label> تخفیف فاکتور (ریال)</label>
                            <rsuite.Input disabled={DiscountType == 0 ? false : true} value={PN.sliceNumber(DiscountPrice)} onChange={Change_DiscountPrice} onBlur={Blur_Header} />
                            <rsuite.Text className='Font10 float-start' as='sub'>{DiscountPrice != "0" ? <>{PN.convert(DiscountPrice)} ریال</> : ""}</rsuite.Text>

                        </rsuite.Col>



                    </rsuite.Row>
                    <hr />

                    <rsuite.Row className="p-1">
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <rsuite.Button appearance="primary" color="green" size='xs'
                                onClick={() => NewItem()}>
                                اضافه شدن محصول جدید
                            </rsuite.Button>
                        </rsuite.Col>
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>


                            <rsuite.Table height={320} data={ItemList} rowHeight={70} headerHeight={50} wordWrap>
                                <rsuite.Table.Column width={50} align="center"  >

                                    <rsuite.Table.HeaderCell>#</rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell dataKey='row' />
                                </rsuite.Table.Column>
                                {/* <rsuite.Table.Column width={50} align="center"  >

                                    <rsuite.Table.HeaderCell>
                                        <rsuite.Checkbox
                                            inline
                                            checked={checked}
                                            indeterminate={indeterminate}
                                            onChange={(e, checked) => Item_CheckAll(checked)}
                                        />
                                    </rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell>
                                        {(rowData) => {
                                            return <>
                                                <rsuite.Checkbox
                                                    value={rowData.DiscountType}
                                                    inline
                                                    onChange={(e, checked) => ItemDiscountType_Check(checked, rowData.row)}
                                                    checked={rowData.DiscountType}
                                                    disabled={rowData.Editable ? false : true}
                                                />
                                            </>
                                        }}

                                    </rsuite.Table.Cell>
                                </rsuite.Table.Column> */}

                                <rsuite.Table.Column width={100} flexGrow={1} resizable>
                                    <rsuite.Table.HeaderCell>محصول </rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell  >
                                        {(rowData) => {
                                            return <>

                                                {rowData.status == 'EDIT' ? (
                                                    <Auto_Product className="rs-input" value={rowData.Product}
                                                        onChange={value => { Change_Item?.(rowData.row, "ProductRef", value); }}
                                                        onSelect={value => { Select_Item?.(rowData.row, "ProductRef", value); }}
                                                        onKeyUp={value => ItemOnKeyUp(value, rowData.row)}

                                                        ref={ProductRef} />
                                                ) : (
                                                    <text>
                                                        {rowData.Product}
                                                    </text>
                                                )}
                                            </>
                                        }}

                                    </rsuite.Table.Cell>
                                </rsuite.Table.Column>


                                <rsuite.Table.Column width={100} >
                                    <rsuite.Table.HeaderCell>تعداد</rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell  >
                                        {(rowData) => {
                                            return <>

                                                {rowData.status == 'EDIT' ? (

                                                    <rsuite.Input className='CountItem' value={rowData.Count}
                                                        onChange={value => { Change_Item?.(rowData.row, "Count", value); }}
                                                        onBlur={value => { Blur_Item?.(rowData.row, "Count", value); }}
                                                        onKeyUp={value => ItemOnKeyUp(value, rowData.row)}
                                                    />


                                                ) : (
                                                    <text>

                                                        {rowData.Count}
                                                    </text>
                                                )}
                                            </>
                                        }}

                                    </rsuite.Table.Cell>
                                </rsuite.Table.Column>


                                <rsuite.Table.Column fullText flexGrow={1} >
                                    <rsuite.Table.HeaderCell>قیمت واحد (ریال)</rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell >
                                        {(rowData) => {
                                            return <>
                                                {rowData.status == 'EDIT' ? (
                                                    <>

                                                        <rsuite.Input value={PN.sliceNumber(rowData.Price)}
                                                            onChange={value => { Change_Item?.(rowData.row, "Price", value); }}
                                                            onBlur={value => { Blur_Item?.(rowData.row, "Price", value); }}
                                                            onKeyUp={value => ItemOnKeyUp(value, rowData.row)}

                                                        />
                                                        <rsuite.Text className='Font8 float-start' as='sub'>{rowData.Price != "0" ? <>{PN.convert(rowData.Price)} ریال</> : ""}</rsuite.Text>
                                                    </>

                                                ) : (
                                                    <text>
                                                        {PN.sliceNumber(rowData.Price)}
                                                    </text>
                                                )}
                                            </>
                                        }}
                                    </rsuite.Table.Cell>
                                </rsuite.Table.Column>
                                {DiscountType != 0 ?

                                    <rsuite.Table.Column fullText width={100} >
                                        <rsuite.Table.HeaderCell>تخفیف (%)</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell >
                                            {(rowData) => {
                                                return <>
                                                    {rowData.status == 'EDIT' ? (
                                                        <>

                                                            <rsuite.Input disabled={rowData.DiscountType == 0 ? true : false} value={rowData.DiscountPercent}
                                                                onChange={value => { Change_Item?.(rowData.row, "DiscountPercent", value); }}
                                                                onBlur={value => { Blur_Item?.(rowData.row, "DiscountPercent", value); }}
                                                                onKeyUp={value => ItemOnKeyUp(value, rowData.row)}


                                                            />
                                                        </>

                                                    ) : (
                                                        <text>
                                                            {rowData.DiscountPercent}

                                                        </text>
                                                    )}
                                                </>
                                            }}

                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>
                                    : <></>}

                                <rsuite.Table.Column fullText flexGrow={1} >
                                    <rsuite.Table.HeaderCell>تخفیف واحد (ریال)</rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell >
                                        {(rowData) => {
                                            return <>
                                                {rowData.status == 'EDIT' ? (
                                                    <>

                                                        <rsuite.Input disabled={rowData.DiscountType == 1 ? true : false}
                                                            value={PN.sliceNumber(rowData.DiscountPrice)}
                                                            onChange={value => { Change_Item?.(rowData.row, "DiscountPrice", value); }}
                                                            onBlur={value => { Blur_Item?.(rowData.row, "DiscountPrice", value); }}
                                                            onKeyUp={value => ItemOnKeyUp(value, rowData.row)}


                                                        />
                                                        <rsuite.Text className='Font8 float-start' as='sub'>{rowData.DiscountPrice != "0" ? <>{PN.convert(rowData.DiscountPrice)} ریال</> : ""}</rsuite.Text>
                                                    </>

                                                ) : (
                                                    <text>
                                                        {PN.sliceNumber(rowData.DiscountPrice)}
                                                    </text>
                                                )}
                                            </>
                                        }}
                                    </rsuite.Table.Cell>
                                </rsuite.Table.Column>
                                {/* <rsuite.Table.Column fullText flexGrow={1} >
                                    <rsuite.Table.HeaderCell>تخفیف کل (ریال)</rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell >
                                        {(rowData) => {
                                            return <>
                                                {rowData.status == 'EDIT' ? (
                                                    <>
                                                        <rsuite.Input disabled  value={PN.sliceNumber(rowData.HeaderDiscount*1+rowData.DiscountPrice*1)}/>
                                                        <rsuite.Text className='Font8 float-start' as='sub'>{rowData.HeaderDiscount*1+rowData.DiscountPrice*1 != "0" ? <>{PN.convert(rowData.HeaderDiscount*1+rowData.DiscountPrice*1)} ریال</> : ""}</rsuite.Text>
                                                    </>

                                                ) : (
                                                    <text>
                                                        {PN.sliceNumber(rowData.HeaderDiscount*1+rowData.DiscountPrice*1)}
                                                    </text>
                                                )}
                                            </>
                                        }}
                                    </rsuite.Table.Cell>
                                </rsuite.Table.Column> */}
                                {Tax != 0 ?
                                    <rsuite.Table.Column fullText flexGrow={1} >
                                        <rsuite.Table.HeaderCell>مالیات واحد (ریال)</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell >
                                            {(rowData) => {
                                                return <>
                                                    {rowData.status == 'EDIT' ? (
                                                        <>

                                                            <rsuite.Input disabled value={PN.sliceNumber(rowData.Tax)} />
                                                            <rsuite.Text className='Font8 float-start' as='sub'>{rowData.Tax != "0" ? <>{PN.convert(rowData.Tax)} ریال</> : ""}</rsuite.Text>
                                                        </>

                                                    ) : (
                                                        <text>
                                                            {PN.sliceNumber(rowData.Tax)}
                                                        </text>
                                                    )}
                                                </>
                                            }}
                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>
                                    : <></>}

                                <rsuite.Table.Column fullText flexGrow={1} >
                                    <rsuite.Table.HeaderCell>قیمت تمام شده هر واحد در کاردکس (ریال)</rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell >
                                        {(rowData) => {
                                            return <>
                                                {rowData.status == 'EDIT' ? (
                                                    <>

                                                        <rsuite.Input disabled value={PN.sliceNumber(rowData.FinalPrice)} />
                                                        <rsuite.Text className='Font8 float-start' as='sub'>{rowData.FinalPrice != "0" ? <>{PN.convert(rowData.FinalPrice)} ریال</> : ""}</rsuite.Text>
                                                    </>

                                                ) : (
                                                    <text>
                                                        {PN.sliceNumber(rowData.FinalPrice)}
                                                    </text>
                                                )}
                                            </>
                                        }}
                                    </rsuite.Table.Cell>
                                </rsuite.Table.Column>

                                <rsuite.Table.Column fullText flexGrow={1} >
                                    <rsuite.Table.HeaderCell>قیمت کل (ریال)</rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell>
                                        {(rowData) => {
                                            return <>
                                                {rowData.status == 'EDIT' ? (
                                                    <>
                                                        <rsuite.Input value={PN.sliceNumber(rowData.TotalPrice)} disabled />
                                                        <rsuite.Text className='Font8 float-start' as='sub'>{rowData.TotalPrice != "0" ? <>{PN.convert(rowData.TotalPrice)} ریال</> : ""}</rsuite.Text>
                                                    </>
                                                ) : (
                                                    <text>
                                                        {PN.sliceNumber(rowData.TotalPrice)}
                                                    </text>
                                                )}
                                            </>
                                        }}
                                    </rsuite.Table.Cell>
                                </rsuite.Table.Column>



                                <rsuite.Table.Column width={100} fixed='right'>
                                    <rsuite.Table.HeaderCell></rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell>
                                        {(rowData) => {
                                            return <>
                                                {rowData.Editable ?
                                                    !rowData.ForParent ?
                                                        <>

                                                            {rowData.status != "EDIT" ? <BiIcon.BiEditAlt onClick={() => onEditItem(rowData.row)} className='fs-6 Cursor' />
                                                                :
                                                                <BiIcon.BiSave onClick={() => SaveItem(rowData.row)} className='fs-6 text-success Cursor' />
                                                            }
                                                            &nbsp;&nbsp;&nbsp;
                                                            <BiIcon.BiTrash onClick={() => DeleteItem(rowData.row)} className='fs-6 text-danger Cursor' />
                                                        </>
                                                        :
                                                        <BiIcon.BiSave onClick={() => SaveItem(rowData.row)} className='fs-6 text-success Cursor' />
                                                    :
                                                    <></>
                                                }
                                            </>
                                        }}
                                    </rsuite.Table.Cell>
                                </rsuite.Table.Column>
                            </rsuite.Table>



                        </rsuite.Col>



                    </rsuite.Row>
                    <hr />
                    <rsuite.Row className='p-1 Font17 '>
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className='mt-2'>
                            <b>قیمت آیتم ها : </b> {PN.sliceNumber(SumItemPrice)} ریال
                            &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='Font10' as='sub'>{HeaderDiscount != "0" ? <>{PN.convert(SumItemPrice)} ریال</> : ""}</rsuite.Text>

                        </rsuite.Col>
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={Tax != 0 ? 'mt-2' : 'hide'}>
                            <b>مالیات کل : </b> {PN.sliceNumber(HeaderTax)} ریال
                            &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='Font10' as='sub'>{HeaderTax != "0" ? <>{PN.convert(HeaderTax)} ریال</> : ""}</rsuite.Text>

                        </rsuite.Col>
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className='mt-2'>
                            <b>تخفیف کل : </b> {PN.sliceNumber(HeaderDiscount)} ریال
                            &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='Font10' as='sub'>{HeaderDiscount != "0" ? <>{PN.convert(HeaderDiscount)} ریال</> : ""}</rsuite.Text>

                        </rsuite.Col>
                        {/* <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className='mt-2'>
                            <b>قیمت با در نظر گرفتن مالیات : </b> {PN.sliceNumber(SumItemPrice * 1 + HeaderTax * 1)} ریال
                            &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='Font10' as='sub'>{SumItemPrice * 1 + HeaderTax * 1 != 0 ? <>{PN.convert(SumItemPrice * 1 + HeaderTax * 1)} ریال</> : ""}</rsuite.Text>

                        </rsuite.Col> */}
                        {/* <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className='mt-2'>
                            <b>قیمت با در نظر گرفتن مالیات و تخفیف : </b> {PN.sliceNumber(SumTotalPrice)} ریال
                            &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='Font10' as='sub'>{SumTotalPrice * 1 != 0 ? <>{PN.convert(SumTotalPrice)} ریال</> : ""}</rsuite.Text>

                        </rsuite.Col> */}
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className='mt-2 '>
                            <b>مبلغ فاکتور : </b> <text>  {PN.sliceNumber(HeaderPrice)} ریال </text>
                            &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='Font10' as='sub'>{HeaderPrice != "0" ? <>{PN.convert(HeaderPrice)} ریال</> : ""}</rsuite.Text>

                        </rsuite.Col>
                    </rsuite.Row>
                    <rsuite.Row>
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <rsuite.Divider></rsuite.Divider>

                            <small><b>Enter : </b> اضافه شدن محصول جدید <b> | Tab : </b>  جابه جایی در ستون رو به جلو <b>| Shift+Tab :</b> جابه جایی در ستون رو به عقب <b>| Delete :</b> حذف ستون <b>| Enter :</b> اضافه شدن ستون
                                <b>| ESC :</b> بازگشت به صفحه قبل
                                <b>| Shift+s :</b> ثبت نهایی فاکتور
                                <b>| Shift+r :</b> ثبت نهایی فاکتور و تبدیل به رسید
                                <b>| Shift+p :</b> ثبت نهایی فاکتور و پرینت
                                <b>| Shift+N :</b> جدید

                            </small>
                        </rsuite.Col>
                    </rsuite.Row>
                </rsuite.Panel >
            </div >


            <Modal show={ConfirmModal} onHide={() => setConfirmModal(false)} size="xs" scrollable >
                <Modal.Header >
                    <Modal.Title className='fs-5'> </Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <rsuite.Grid fluid>
                        <rsuite.Row className='p-1'>


                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <label> تاریخ رسید </label>
                                <DatePicker className="rs-input" isGregorian={false} timePicker={false} icon={BiIcon.BiCalendar} value={RecieptDate} onChange={RecieptDate_Change} />
                            </rsuite.Col>


                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <label>  انبار </label>
                                <Drp_StoreRoom className='rs-input' value={StoreRoomId} onChange={(value) => setStoreRoomId(value)} ref={StoreRef} />
                            </rsuite.Col>

                        </rsuite.Row>
                    </rsuite.Grid>
                </Modal.Body>
                <Modal.Footer>
                    <rsuite.Button appearance="primary" color="green" onClick={() => Save(1)}>
                        ذخیره
                    </rsuite.Button>
                    <rsuite.Button appearance="subtle" onClick={() => setConfirmModal(false)}>
                        بستن
                    </rsuite.Button>

                </Modal.Footer>
            </Modal>



        </Layout >


    )
}

export default InsertBuyOrderIndex;